export const DEFAULT_CARDS_PER_PAGE = 48;
export const DEFAULT_CARDS_PER_PAGE_MOBILE = 24;
export const SPECIAL_SIZE_CARDS_PER_PAGE = 50;

export const PARAM_KEY_TO__FILTER = {
  has_foil: 'foil',
  has_custom_photo: 'customphoto',
  has_no_custom_photo: 'nocustomphoto',
  has_magnet: 'magnet',
  is_landscape: 'landscape',
  is_portrait: 'portrait',
  is_vow_renewal: 'elopementandvowrenewal',
  featured_artist: 'featuredArtist',
  is_letterpress: 'is_letterpress',
  single_sample_available: 'multisampleenabled',
};

export const SORT_OPTIONS = [
  { value: 'featured', label: 'Featured' },
  { value: 'launch_date', label: 'Recently added' },
  { value: 'popularity', label: 'Best sellers' },
];
export const SORT_OPTIONS_DIGITAL = [
  { value: 'featured', label: 'Featured' },
  { value: 'launch_date', label: 'Recently added' },
  { value: 'popularity', label: 'Most popular' },
];

export const SORT_DEFAULT = SORT_OPTIONS[0].value;
export const SORT_DEFAULT_LABEL = SORT_OPTIONS[0].label;

export const PARAM_CATEGORIES = [
  {
    urlKey: 'features',
    keys: ['has_foil', 'has_custom_photo', 'has_no_custom_photo', 'has_magnet'],
  },
  {
    urlKey: 'orientations',
    keys: ['is_portrait', 'is_landscape'],
  },
  {
    urlKey: 'receptionOnly',
    keys: ['is_vow_renewal'],
  },
  {
    urlKey: 'featuredArtists',
    keys: ['featured_artist'],
  },
  {
    urlKey: 'is_letterpress',
    keys: ['is_letterpress'],
  },
  {
    urlKey: 'color',
    keys: ['multiColor'],
  },
  {
    urlKey: 'sorts',
    keys: ['sorts'],
  },
];
